module.exports = __webpack_public_path__ + "img/ems02.3cf343be.png";